var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91.302,
    height: 105.391,
    viewBox: "0 0 91.302 105.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38859",
    x: 39.5,
    y: 0,
    width: 51.802,
    height: 51.792,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_notifications",
    "data-name": "No notifications",
    transform: "translate(4031 7468.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38858",
    "data-name": "Path 38858",
    d: "M88.078,80.735c-4.941-5.422-3.67-19.116-3.67-31.216,0-9.913-5.738-20.841-17.432-24.472a8.624,8.624,0,0,0-17.226,0C38.058,28.678,32.319,39.606,32.319,49.519c0,12.1,1.271,25.794-3.671,31.216S17.667,89.141,17.667,97.411H47.939a10.354,10.354,0,0,0,20.706,0H99.06C99.06,89.141,93.02,86.159,88.078,80.735Z",
    transform: "translate(-4048.667 -7470.506)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4031, -7468.26)",
    filter: "url(#Path_38859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38859-2",
    "data-name": "Path 38859",
    d: "M66.7,42.123a24.4,24.4,0,1,1-24.4-24.4,24.4,24.4,0,0,1,24.4,24.4",
    transform: "translate(23.1 -17.23)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(-3966 -7457)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "MyriadPro-Semibold, myriad-pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.04,
    y: 23
  }, "0")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonotifications);
export default __webpack_public_path__ + "static/media/No notifications.16e3ee35d4774ab3c9a68015f74726a1.svg";
export { ForwardRef as ReactComponent };